// SeoBlogMobileComponent.js
import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { linkProps } from '../../../utils/appLink';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

// Cloudflare R2 SVG
const SEO_QNA_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/SeoQnAVector.svg';

const SeoBlogMobileComponent = ({ data }) => {
  const { title, description, cards = [] } = data || {};

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '100vw',
          borderRadius: '48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxSizing: 'border-box',
        }}
      >
        {/* Title */}
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '2rem',
            lineHeight: '2.125rem',
            letterSpacing: '-0.03em',
            color: '#162F3B',
            textAlign: 'center',
            px: '16px',
            whiteSpace: 'pre-line',
          }}
        >
          {title}
        </Typography>

        {/* Description */}
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
            fontSize: '1.25rem',
            lineHeight: '1.5rem',
            letterSpacing: '-0.03em',
            color: '#162F3B',
            textAlign: 'center',
            mt: '16px',
            mb: '40px',
            px: '16px',
            boxSizing: 'border-box',
            whiteSpace: 'pre-line',
          }}
        >
          {description}
        </Typography>

        {/* Cards (auto-height) */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            alignItems: 'stretch',
            width: '100%',
            px: '16px',
            boxSizing: 'border-box',
          }}
        >
          {cards.map((card, i) => (
            <ScrollFadeWrapper key={i} delay={i * 0.1}>
              <Box
                sx={{
                  backgroundColor: '#FFFFFF',
                  borderRadius: '24px',
                  boxShadow:
                    '0px 1px 2px rgba(162, 172, 177, 0.2), 0px 12px 24px -4px rgba(22, 47, 59, 0.12)',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  alignSelf: 'stretch',
                  pt: '24px',
                  pb: '16px',
                  px: '24px',
                  boxSizing: 'border-box',
                }}
              >
                {/* Vector centered above text */}
                <Box
                  sx={{
                    position: 'relative',
                    width: 120,
                    height: 120,
                    mb: '16px',
                  }}
                >
                  <Image
                    width={120}
                    height={120}
                    src={SEO_QNA_VECTOR_URL}
                    alt="SEO Q&A vector graphic"
                    sx={{ width: '100%', height: '100%' }}
                  />
                  {card.icon && (
                    <Image
                      width={64}
                      height={64}
                      src={card.icon}
                      alt="icon"
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 64,
                        height: 64,
                        objectFit: 'contain',
                      }}
                    />
                  )}
                </Box>

                {/* Title */}
                <Typography
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 700,
                    fontSize: '1.25rem',
                    lineHeight: '1.5rem',
                    color: '#162F3B',
                    mb: '8px',
                    textAlign: 'center',
                    wordBreak: 'break-word',
                  }}
                >
                  {card.title}
                </Typography>

                {/* Text */}
                <Typography
                  sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 400,
                    fontSize: '0.95rem',
                    lineHeight: '1.4rem',
                    color: '#162F3B',
                    textAlign: 'center',
                    wordBreak: 'break-word',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {card.text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
                    if (/^\*\*[^*]+\*\*$/.test(part)) {
                      return (
                        <strong key={i} style={{ fontWeight: 700 }}>
                          {part.slice(2, -2)}
                        </strong>
                      );
                    }
                    return part;
                  })}
                </Typography>

                {/* Learn more */}
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    mt: '12px',
                    justifyContent: 'flex-end',
                  }}
                >
                  {card.link && (
                    <Link
                      {...linkProps(card.link)}
                      sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        color: '#162F3B',
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline',
                          color: '#C7CA00',
                        },
                      }}
                    >
                      Learn more
                    </Link>
                  )}
                </Box>
              </Box>
            </ScrollFadeWrapper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SeoBlogMobileComponent;
